import Vue from "vue";
import VueRouter from "vue-router";
import store from '@/store';

import Home from "@/components/views/Home";
import Intro from "@/components/views/Intro";
import GameOver from '@/components/views/GameOver';
import LoadingScreen from '@/components/views/LoadingScreen';

import game from "@/router/game.routes";

Vue.use(VueRouter);

const router = new VueRouter({
	mode: "abstract",
	routes: [
		{
			path: "/",
			component: Home,
			meta: { muteTogglePosition: 'route-based-positioning' },
			beforeEnter(to, from, next) {
				if (!store.state.global.assets.loaded) {
					next({ path: "/loading" });
				} else {
					next();
				}
			},
		},
		{
			path: '/loading',
			component: LoadingScreen,
			meta: { muteTogglePosition: 'route-based-positioning' },
		},
		{
			path: "/intro",
			component: Intro,
			meta: { muteTogglePosition: 'route-based-positioning' },
		},
		{
			path: '/gameover',
			component: GameOver,
		},
		...game,
	],
});

// Prevent errors from redirects in beforeEnter Hooks
// This *should* become unnecessary in vue-router 4 // https://github.com/vuejs/rfcs/pull/150
VueRouter.prototype.unwrappedReplace = VueRouter.prototype.replace;
VueRouter.prototype.unwrappedPush = VueRouter.prototype.push;

VueRouter.prototype.replace = function push(location, onComplete, onAbort = () => {}) {
	this.unwrappedReplace(location, onComplete, onAbort);
};
VueRouter.prototype.push = function push(location, onComplete, onAbort = () => {}) {
	this.unwrappedPush(location, onComplete, onAbort);
};

// TODO: Using scrollBehavior in the router instance would be ideal,
// but does not get triggered under the current navigation circumstances.
// Troubleshoot for next application to avoid document.getElementById('app')
router.afterEach(() => {
	document.getElementById('app').scrollIntoView();
});

export default router;
